import Navbar from "../../Navbar";
import { UrlApi } from "../../../services/apirest";
import React, { useState, useEffect, useMemo } from "react";

import {
  // Componentes para los estilos
  Container,
  Typography,
  Snackbar,
  SnackbarContent,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
  Checkbox,
  FormControlLabel,
  Select,
  Divider,
  Grid,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import PersonOffTwoToneIcon from "@mui/icons-material/PersonOffTwoTone";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import AppRegistrationTwoToneIcon from "@mui/icons-material/AppRegistrationTwoTone";
import PersonAddTwoToneIcon from "@mui/icons-material/PersonAddTwoTone";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import PersonRemoveTwoToneIcon from "@mui/icons-material/PersonRemoveTwoTone";
import PersonTwoToneIcon from "@mui/icons-material/PersonTwoTone";
import HowToRegTwoToneIcon from "@mui/icons-material/HowToRegTwoTone";
import DialogContentText from "@mui/material/DialogContentText";
import moment from "moment";

//componente para la seleccion de las vindas y valida si ya se elegio una vianda la seccion se desabilita como los dias feriados

//para el editar mejor es hacerlo desde el resumen del empleado para simplificar fin

function Selecionarmenu() {
  const [menusDiarios, setMenusDiarios] = useState([]);
  const [menusRotativos, setMenusRotativos] = useState([]);

  const [desabilitarmenu, setDesabilitarmenu] = useState(false);

  // localStorage
  const usuarioLogueado = localStorage.getItem("user");
  const usuarioidsucursal = localStorage.getItem("sucursal");
  const sucursalnombre = localStorage.getItem("sucursalnombre");
  //--------------------------------------------------------
  //separe en estados la seleccion porque chocaban con el id_menu
  const [menusDiariosSeleccionados, setMenusDiariosSeleccionados] = useState(
    []
  );
  const [menusRotativosSeleccionados, setMenusRotativosSeleccionados] =
    useState([]);
  const [disBtn, setDisBtn] = useState(false);
  //--------------------------------------------------------
  //estados para mostrar si el usuario ya tiene viandas para esa fecha
  const [fechaDesde, setFechaDesde] = useState();
  const [fechaHasta, setFechaHasta] = useState();
  const [pedidoRepetido, setPedidoRepetido] = useState([]);
  const [editandoPedidos, setEditandoPedidos] = useState(false);
  //--------------------------------------------------------

  const [mensaje, setMensaje] = useState();

  const ObtenermenusDiarios = () => {
    fetch(UrlApi + "/viandasfech/obtenermenudiario")
      .then((data) => data.json())
      .then((data) => {
        // Ordenamos los menús diarios por fecha (de lunes a domingo)
        //
        const menusOrdenados = data.sort(
          (a, b) => new Date(a.fecha) - new Date(b.fecha)
        );
        setMenusDiarios(menusOrdenados);
      });
  };
  const ObtenermenusRotativos = () => {
    fetch(UrlApi + "/viandasfech/obtenermenurotativo2")
      .then((data) => data.json())
      .then((data) => setMenusRotativos(data));
  };
  useEffect(() => {
    ObtenermenusDiarios();
    ObtenermenusRotativos();
  }, []);

  //--------------------------------------------------------
  const [modoEdicion, setModoEdicion] = useState(false);
  const [seleccion, setSeleccion] = useState([]);

  const [seleccionrepedido, setSeleccionrepedido] = useState();

  const handleEditar = () => {
    setModoEdicion(true);
    // Acá podrías setear los pedidos existentes al estado actual del formulario
    setSeleccion(pedidoRepetido); // o el nombre de tu estado real
  };

  const [pedidosbloqueados, setpedidosbloqueados] = useState(false);

  // const handleToggleMenuDiario = (menu) => {
  //   setMenusDiariosSeleccionados((prev) => {
  //     const existe = prev.find((m) => m.id_menu === menu.id_menu);
  //     if (existe) {
  //       return prev.filter((m) => m.id_menu !== menu.id_menu);
  //     } else {
  //       return [...prev, { ...menu, id_tipo: 305 }];
  //     }
  //   });
  // };

  // const handleSeleccionRotativo = (menuDiario, idMenuRotativo) => {
  //   const menuRotativo = menusRotativos.find((m) => m.id_menu === idMenuRotativo);
  //   if (!menuRotativo) return;

  //   setMenusRotativosSeleccionados((prev) => {
  //     const sinFechaRepetida = prev.filter((m) => m.fecha !== menuDiario.fecha);
  //     return [...sinFechaRepetida, { ...menuRotativo, id_tipo: 306, fecha: menuDiario.fecha }]; //aca vuelve a setear los menues rotativos y le agrega la fecha de seleccion del menu para filtrar
  //   });
  // };

  const handleToggleMenuDiario = (menu) => {
    setMenusDiariosSeleccionados((prev) => {
      const existe = prev.find((m) => m.id_menu === menu.id_menu);

      if (existe) {
        // Si ya está seleccionado, lo eliminamos
        return prev.filter((m) => m.id_menu !== menu.id_menu);
      } else {
        // ⚠️ Validar si ya hay un menú rotativo seleccionado para esa fecha
        const rotativoYaSeleccionado = menusRotativosSeleccionados.find(
          (m) => m.fecha === menu.fecha
        );
        if (rotativoYaSeleccionado) {
          alert("Seleccione solo una opción por día (diario o rotativo)");
          return prev; // No agregamos nada
        }

        return [...prev, { ...menu, id_tipo: 305 }];
      }
    });
  };

  const handleSeleccionRotativo = (menuDiario, idMenuRotativo) => {
    const menuRotativo = menusRotativos.find(
      (m) => m.id_menu === idMenuRotativo
    );
    if (!menuRotativo) return;

    // ⚠️ Validar si ya hay un menú diario seleccionado para esa fecha
    const yaSeleccionadoDiario = menusDiariosSeleccionados.find(
      (m) => m.fecha === menuDiario.fecha
    );
    if (yaSeleccionadoDiario) {
      alert("Seleccione solo una opción por día (diario o rotativo)");
      return; // No agregamos nada
    }

    setMenusRotativosSeleccionados((prev) => {
      const sinFechaRepetida = prev.filter((m) => m.fecha !== menuDiario.fecha);
      return [
        ...sinFechaRepetida,
        { ...menuRotativo, id_tipo: 306, fecha: menuDiario.fecha },
      ];
    });
  };

  const pedidosParaGuardar = [
    ...menusDiariosSeleccionados,
    ...menusRotativosSeleccionados,
  ]
    .sort((a, b) => new Date(a.fecha) - new Date(b.fecha)) // Ordenar por fecha ascendente
    .map((item) => ({
      id_menu: item.id_menu,
      fecha: moment(item.fecha).format("YYYY-MM-DD"),
      observaciones: "",
      username: usuarioLogueado,
      id_sucursal: usuarioidsucursal,
    }));

  //boton
  const deseleccionarPorFecha = (fecha) => {
    setMenusDiariosSeleccionados((prev) =>
      prev.filter((m) => m.fecha !== fecha)
    );

    setMenusRotativosSeleccionados((prev) =>
      prev.filter((m) => m.fecha !== fecha)
    );
  };

  const handleGuardar = async (e) => {
    e.preventDefault();
    setDisBtn(true);
    try {
      if (pedidosParaGuardar.length === 0) {
        alert("No seleccionaste ningún menú para guardar.");
        return;
      }

      const response = await fetch(`${UrlApi}/viandas/pedidos/post`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(pedidosParaGuardar),
      });

      if (response.status === 403) {
        alert("Los pedidos se encuentran bloqueados.");
        setpedidosbloqueados(true);
        setMensaje("Los pedidos se encuentran bloqueados");
        return;
      }

      if (!response.ok) {
        throw new Error("Error al guardar los pedidos.");
      }

      alert("¡Pedidos guardados correctamente!");
      setMenusDiariosSeleccionados([]);
      setMenusRotativosSeleccionados([]);
    } catch (error) {
      console.error("Error al guardar:", error);
      alert("Error al guardar los pedido");
    }
  };

  //------------------------------------------------------si el usuario tiene viandas para que no explote----------------
  //para defenir desde hasta usando  menusDiarios
  useEffect(() => {
    if (menusDiarios.length > 0) {
      const fechas = menusDiarios.map((item) => new Date(item.fecha));
      const fechasOrdenadas = fechas.sort((a, b) => a - b);

      setFechaDesde(fechasOrdenadas[0].toISOString().split("T")[0]);
      setFechaHasta(
        fechasOrdenadas[fechasOrdenadas.length - 1].toISOString().split("T")[0]
      );
    }
  }, [menusDiarios]);

  const siUsuarioTieneViandas = () => {
    if (!fechaDesde || !fechaHasta || !usuarioLogueado) return;

    const url = `${UrlApi}/viandasfech/existepedidos/${fechaDesde}_${fechaHasta}?username=${usuarioLogueado}`;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setPedidoRepetido(data); // O el estado que uses
      })
      .catch((err) => console.error("Error al verificar viandas:", err));
  };

  useEffect(() => {
    if (fechaDesde && fechaHasta && usuarioLogueado) {
      siUsuarioTieneViandas();
    }
  }, [fechaDesde, fechaHasta, usuarioLogueado]);

  useEffect(() => {
    if (pedidoRepetido && pedidoRepetido.length > 0) {
      const diarios = pedidoRepetido
        .filter((p) => p.id_tipo === 305)
        .map((p) => ({
          id_menu: p.id_menu,
          fecha: p.fecha,
          id_tipo: p.id_tipo,
          menu: p.menu,
          feriado: p.feriado,
          guarnicion: p.guarnicion,
          observaciones: p.observaciones,
          username: p.username,
          id_sucursal: p.id_sucursal,
          sucursal: p.sucursal,
        }));

      const rotativos = pedidoRepetido
        .filter((p) => p.id_tipo === 306)
        .map((p) => ({
          id_menu: p.id_menu,
          fecha: p.fecha,
          id_tipo: p.id_tipo,
          menu: p.menu,
          feriado: p.feriado,
          guarnicion: p.guarnicion,
          observaciones: p.observaciones,
          username: p.username,
          id_sucursal: p.id_sucursal,
          sucursal: p.sucursal,
        }));

      setSeleccionrepedido(diarios);
      setMenusDiariosSeleccionados(diarios);
      setMenusRotativosSeleccionados(rotativos);
      setEditandoPedidos(true);
    }
  }, [pedidoRepetido]);

  return (
    <>
      <Navbar />
      <br></br>
      <Grid>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column", // Para que los hijos se apilen verticalmente
            alignItems: "center", // Centrado horizontal de los hijos
            justifyContent: "center", // Centrado vertical si hay altura definida
            // minHeight: '100vh',       // O cualquier altura que necesites
            //mt: 4,                    // Margen superior opcional
          }}
        >
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            gutterBottom
          >
            Selección de viandas semanal
          </Typography>

          <Box sx={{ display: "flex", overflowX: "auto", gap: 2, py: 2 }}>
            {menusDiarios.map((menu) => {
              // const estaSeleccionado =   menusDiariosSeleccionados.some((m) => m.id_menu === menu.id_menu);
              const estaSeleccionado = menusDiariosSeleccionados.some(
                (p) => p.fecha === menu.fecha && p.id_menu === menu.id_menu
              );
              const rotativoSeleccionado = menusRotativosSeleccionados.find(
                (m) => m.fecha === menu.fecha
              );

              // Comprobar si ya hay un pedido en esa fecha
              const yaTienePedido = pedidoRepetido.some(
                (p) =>
                  moment(p.fecha).format("YYYY-MM-DD") ===
                  moment(menu.fecha).format("YYYY-MM-DD")
              );

              //const deshabilitado = menu.menu === "No disponible" || yaTienePedido;
              const deshabilitado = menu.menu === "No disponible"; //solo feraidos

              return (
                <Box
                  key={menu.id_menu}
                  sx={{
                    p: 2,
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    minWidth: 250,
                    maxWidth: 250,
                    overflow: "hidden",
                    opacity: deshabilitado ? 0.5 : 1,
                    pointerEvents: deshabilitado ? "none" : "auto",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography variant="subtitle1" noWrap>
                    {moment(menu.fecha).format("dddd DD/MM/YYYY")}
                  </Typography>
                  <Typography variant="body2">Menú diario:</Typography>

                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Checkbox
                      checked={estaSeleccionado}
                      onChange={() => handleToggleMenuDiario(menu)}
                      disabled={deshabilitado}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        color: deshabilitado ? "text.disabled" : "text.primary",
                      }}
                    >
                      <strong>{menu.menu}</strong>
                    </Typography>
                  </Stack>

                  <Select
                    fullWidth
                    value={rotativoSeleccionado?.id_menu || ""}
                    onChange={(e) =>
                      handleSeleccionRotativo(menu, e.target.value)
                    }
                    displayEmpty
                    sx={{ mt: 1 }}
                    disabled={deshabilitado}
                  >
                    <MenuItem value="">Menú rotativo</MenuItem>
                    {menusRotativos.map((opcion) => (
                      <MenuItem key={opcion.id_menu} value={opcion.id_menu}>
                        <Box
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }}
                          title={`${opcion.menu} - ${opcion.guarnicion}`}
                        >
                          {opcion.menu} - {opcion.guarnicion}
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>

                  <Button
                    size="small"
                    color="error"
                    variant="outlined"
                    sx={{ mt: 1 }}
                    onClick={() => deseleccionarPorFecha(menu.fecha)}
                    disabled={deshabilitado}
                  >
                    Quitar selección
                  </Button>

                  {yaTienePedido && (
                    <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                      Ya existe un pedido para este día.
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>

          <Button
            variant="contained"
            color="primary"
            onClick={handleGuardar}
            disabled={disBtn}
          >
            Guardar selección
          </Button>

          {pedidosbloqueados ? (
            <b> Los Pedidos se encuentra bloqueados hasta la nueva carga.</b>
          ) : null}
        </Box>
      </Grid>
    </>
  );
}

export default Selecionarmenu;
